import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
      {categories.map((c) => (
        <Link
          key={c.id}
          to={`/category/${c.id}`}
          className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
        >
          <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-2xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
            <i className={c.icon}></i>
          </span>
          <span className="font-heading font-semibold text-sm text-foreground-900 text-center">
            {c.name}
          </span>
          <span className="text-xs text-foreground-500 line-clamp-2 text-center hidden sm:block">
            {c.desc}
          </span>
        </Link>
      ))}
    </div>
  );
}